var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6668 2.91602H4.58349C4.33349 2.91602 4.08349 2.99935 3.91683 3.24935L2.66683 4.91602C2.25016 5.49935 2.66683 6.24935 3.33349 6.24935H15.4168C15.6668 6.24935 15.9168 6.16602 16.0835 5.91602L17.3335 4.24935C17.7502 3.66602 17.3335 2.91602 16.6668 2.91602Z",
    stroke: "#140D04",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33349 8.33398H15.4168C15.6668 8.33398 15.9168 8.41732 16.0835 8.66732L17.3335 10.334C17.7502 10.9173 17.3335 11.6673 16.6668 11.6673H4.58349C4.33349 11.6673 4.08349 11.584 3.91683 11.334L2.66683 9.66732C2.25016 9.08398 2.66683 8.33398 3.33349 8.33398Z",
    stroke: "#140D04",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6668 13.75H4.58349C4.33349 13.75 4.08349 13.8333 3.91683 14.0833L2.66683 15.75C2.25016 16.3333 2.66683 17.0833 3.33349 17.0833H15.4168C15.6668 17.0833 15.9168 17 16.0835 16.75L17.3335 15.0833C17.7502 14.5 17.3335 13.75 16.6668 13.75Z",
    stroke: "#140D04",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolIcon);
export default __webpack_public_path__ + "static/media/solIcon.fbb2efdd28acbe1e530dff33009da83a.svg";
export { ForwardRef as ReactComponent };